import {VehicleCondition} from '@dms/api/sales';

/** `OPEN_DRIVE_HOURS`, `PAGE_SIZES` and `MAX_WINDOW_DAYS` are shared with the backend. */
export const TEST_DRIVE_CALENDAR = {
  BUSINESS_START_HOUR: 5,
  BUSINESS_END_HOUR: 20,
  OPEN_DRIVE_HOURS: 1,
  PAGE_SIZES: [10, 20, 50],
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE: 1,
  MAX_WINDOW_DAYS: 62,
  RANGE_DAYS: {WEEK: 7, MONTH: 30},
  SEARCH_DEBOUNCE_MS: 500,
  TOOLTIP_CLOSE_DELAY_MS: 150,
} as const;

export const BUSINESS_HOURS_COUNT =
  TEST_DRIVE_CALENDAR.BUSINESS_END_HOUR - TEST_DRIVE_CALENDAR.BUSINESS_START_HOUR;

/** The only test-drivable subset of the 6 platform vehicle conditions. */
export const SETTINGS_VEHICLE_CONDITIONS: VehicleCondition[] = [
  'CONDITION_DEMONSTRATION_CAR',
  'CONDITION_USED',
];
